import { queryOptions } from '@tanstack/react-query';

import { gpSurfacesMapApi } from '../apis/gp-surfaces-map';
import { GpSurfacesMapParams } from '../types/gp-surfaces-map';

import { Globals, getQueriesWithGlobal, useQueriesWithGlobal } from '@data-access';

export const gpSurfacesMapQueries = (global: Globals) => ({
  all: () => [global, 'gp-surfaces-map'] as const,
  map: (params: GpSurfacesMapParams = {}) =>
    queryOptions({
      queryKey: [...gpSurfacesMapQueries(global).all(), params],
      queryFn: () => gpSurfacesMapApi.get(params),
    }),
});

export const useGpSurfacesMapQueries = () =>
  useQueriesWithGlobal(gpSurfacesMapQueries);

export const getGpSurfacesMapQueries = () => getQueriesWithGlobal(gpSurfacesMapQueries);
